import { styled } from "@linaria/react";
import { styleTokens } from "@ideally-ltd/design-tokens";
import { InputText } from "primereact/inputtext";

const PInputText = styled(InputText)<{ ref: React.ForwardedRef<HTMLInputElement>; autoComplete: string }>`
  border: 1px solid ${styleTokens.inputtext.border.color};
  background: white;
  border-radius: 4px;

  &:hover {
    border: 1px solid ${styleTokens.inputtext.border.color};
  }
  &.p-inputtext:enabled:focus {
    box-shadow: none;
  }

  .form-field-invalid > &,
  .form-field-invalid > * > & {
    border: 1px solid ${styleTokens.inputtext.invalid.border.color};
  }
  & > i {
    font-size: 1rem;
    align-items: center;
  }

  &.p-inputtext-sm {
    max-height: 2rem;
  }
`;
export const PInputTextStyle = { PInputText };
